export default __webpack_public_path__ + "static/media/onboarding_imgs_01.35732163.png";